/**
 * UserActionsService
 * @module Services/domain/UserActionsService
 * @description Offers a set of methods to help with user actions
 */

let self = {};
import HttpService from '../http/HttpService';
import LinksProvider from '../http/LinksProvider';

/**
 * Gets a user action
 * @author Sameh Bellez
 * @alias get
 * @memberof module:Services/domain/UserActionsService
 * @returns {promise} A promise containing the user action
 */
self.get = (reference) => {
  return HttpService().get(LinksProvider.get(LinksProvider.API.USER_ACTIONS.USER_ACTION, {reference: reference}))
    .then(result => result.user_action);
};

/**
 * checkStrongAuth
 * @author Seif Khiari
 * @memberof module:Services/domain/UserActionsService
 * @returns {Object}
 */
self.checkStrongAuth = (reference) => {
  return HttpService()
    .get(LinksProvider.get(LinksProvider.API.USER_ACTIONS.CHECK_STRONG_AUTH, { reference }))
    .then(result => result.strong_auth || result);
};

/**
 * cancelStrongAuth
 * @author Amine Elouaer
 * @memberof module:Services/domain/UserActionsService
 * @returns {Object}
 */
self.cancelStrongAuth = (reference) => {
  return HttpService().delete(LinksProvider.get(LinksProvider.API.USER_ACTIONS.USER_ACTION, {reference: reference}));
};

export default self;
